import { apiClient } from '../client';
import { API_ENDPOINTS, CACHE_CONFIG } from '../config';

interface MedicationSearchParams {
  q: string;
  condition?: string;
  insuranceId?: string;
  page?: number;
  limit?: number;
}

interface MedicationPricingParams {
  pharmacyIds?: string[];
  quantity?: number;
  insuranceId?: string;
}

class MedicationService {
  async searchMedications(params: MedicationSearchParams) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });

    return apiClient.get(`${API_ENDPOINTS.medications.search}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getMedicationDetail(medicationId: string) {
    return apiClient.get(API_ENDPOINTS.medications.detail(medicationId), {
      cacheTTL: CACHE_CONFIG.staticDataTTL
    });
  }

  async getMedicationPricing(medicationId: string, params?: MedicationPricingParams) {
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
          if (Array.isArray(value)) {
            value.forEach(v => queryParams.append(key, v));
          } else {
            queryParams.append(key, value.toString());
          }
        }
      });
    }

    return apiClient.get(`${API_ENDPOINTS.medications.pricing(medicationId)}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }
}

export const medicationService = new MedicationService();